import { SelectionFeature, mapStore } from "../store";

export function updateSelection(selection?: SelectionFeature) {
  mapStore.selection = selection;
}

export function updateDetailSelection(detailSelection?: SelectionFeature) {
  mapStore.detailSelection = detailSelection;
}
